import { all, call, put } from 'redux-saga/effects';
import { requestForSaga } from 'utils/request/request';
import { requestCustomErrorMessage } from 'utils/request/requestCustomErrorMessage';
import { SEND_DIAGNOSTICS, SEND_PARSING_ERRORS } from './constants';

import { takeEvery } from 'containers/ErrorBoundary';
import { sendFinished } from './actions';

function* sendDiagnosticsSaga() {
  try {
    yield put({ type: `${SEND_PARSING_ERRORS}_START` });
    yield call(requestForSaga, { url: '/support/callhome', method: 'POST' });
    yield put({ type: `${SEND_PARSING_ERRORS}_SUCCESS` });
  } catch (e) {
    yield put({ type: `${SEND_PARSING_ERRORS}_ERROR` });
    yield call(requestCustomErrorMessage, 'danger', e);
    throw e;
  }
  yield put(sendFinished());
}

export function* defaultSaga() {
  yield all([takeEvery(SEND_DIAGNOSTICS, sendDiagnosticsSaga)]);
}

export default defaultSaga;
